import { SvgIcon } from "@mui/material";
import React, { SVGProps } from "react";
import { ImsIconProps } from "../../@types/Components";
import {
  IMS_ICON_DEFAULT_FILL,
  IMS_ICON_DEFAULT_FONT_SIZE,
  IMS_ICON_DEFAULT_HEIGHT,
  IMS_ICON_DEFAULT_WIDTH,
  MUI_ICON_VIEWBOX,
} from "../../utils/constants";

/**
 * Component that will load our custom svg files as svg components and wraps them into the SvgIcon wrapper from MUI to achieve similar behavior.
 *
 * @param {ImsIconProps} props the provided parameters for this icon component.
 */
const ImsIcon: React.FC<ImsIconProps> = (props: ImsIconProps) => {
  const {
    Icon,
    width = IMS_ICON_DEFAULT_WIDTH,
    height = IMS_ICON_DEFAULT_HEIGHT,
    fill = IMS_ICON_DEFAULT_FILL,
    className = "",
    svgProps,
    style = {},
  } = props;

  const configuredSvgProps: SVGProps<SVGSVGElement> = {
    fill: fill,
    fontSize: IMS_ICON_DEFAULT_FONT_SIZE,
    width: width,
    height: height,
    ...svgProps,
  };

  try {
    return (
      <SvgIcon
        className={className}
        style={{
          fontSize: IMS_ICON_DEFAULT_FONT_SIZE,
          maxWidth: "1em",
          maxHeight: "1em",
          height: "1em",
          width: "1em",
          ...style,
        }}
        viewBox={MUI_ICON_VIEWBOX}
      >
        <Icon {...configuredSvgProps} />
      </SvgIcon>
    );
  } catch (error) {
    console.error(`ImsIcon "${Icon.displayName}" not found.`);
    return null;
  }
};

export default ImsIcon;
